import React from 'react';

const MODES = [
  { key: 'easy', icon: '📖', label: '쉬운 해설', desc: '전문 용어를 풀어서' },
  { key: 'story', icon: '✍️', label: '단편소설', desc: '이야기로 읽는 뉴스' },
  { key: 'debate', icon: '⚖️', label: '찬반 토론', desc: '양측 논거를 균형있게' },
  { key: 'level', icon: '🎯', label: '난이도 변환', desc: '맞춤 수준으로' },
];

const DIFFICULTIES = [
  { key: 'elementary', label: '초등학생' },
  { key: 'middle_school', label: '중학생' },
  { key: 'high_school', label: '고등학생' },
  { key: 'adult', label: '일반 성인' },
  { key: 'expert', label: '전문가' },
];

function OptionsSection({
  transformMode, setTransformMode,
  difficulty, setDifficulty,
  protectedFacts, setProtectedFacts,
}) {
  return (
    <section className="options-section">
      <h3>변환 옵션 선택</h3>

      {/* 모드 선택 */}
      <div className="mode-selector">
        {MODES.map((mode) => (
          <button
            key={mode.key}
            className={`mode-btn ${transformMode === mode.key ? 'active' : ''}`}
            onClick={() => setTransformMode(mode.key)}
          >
            <span className="mode-icon">{mode.icon}</span>
            <span className="mode-label">{mode.label}</span>
            <span className="mode-desc">{mode.desc}</span>
          </button>
        ))}
      </div>

      {/* 난이도 선택 (level 모드에서만 표시) */}
      {transformMode === 'level' && (
        <div className="difficulty-selector">
          <label>난이도 선택</label>
          <div className="difficulty-options">
            {DIFFICULTIES.map((diff) => (
              <button
                key={diff.key}
                className={`diff-btn ${difficulty === diff.key ? 'active' : ''}`}
                onClick={() => setDifficulty(diff.key)}
              >
                {diff.label}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* 팩트 태그 입력 */}
      <div className="facts-input">
        <label>보호할 핵심 팩트 (선택사항)</label>
        <p>
          변환 시 절대 변경되면 안 되는 수치, 인명, 날짜 등을 한 줄에 하나씩 입력하세요.
        </p>
        <textarea
          placeholder={"예시:\n환율 1,470원\n한국은행\n2026년 2월 5일\n이재명 대통령"}
          value={protectedFacts}
          onChange={(e) => setProtectedFacts(e.target.value)}
        />
      </div>
    </section>
  );
}

export default OptionsSection;
